import { IconProps } from "./types";
import React from "react";

export const LoadingIcon = ({
  className = "",
  fill = "#147EFB",
  width = 25,
  height = 25,
  style = {},
}: IconProps): React.ReactElement => (
  <span
    style={{
      ...style,
      borderColor: fill,
      width: width,
      height: height,
      display: "block",
    }}
    className={`mx-auto animate-spin rounded-full border-4 border-solid border-t-transparent ${className}`}
  />
);
